import { environmentConfig } from "@src/appV2/environment";

import { AVAILABILITIES_PATH } from "../constants";

export const WORKER_AVAILABILITIES_URL = `${environmentConfig.REACT_APP_WORKER_SERVICE_URL}${AVAILABILITIES_PATH}`;
